// extracted by css-extract-rspack-plugin
export default {"root":"root-Tz1JE_ palette-Q46_UD","list":"list-C9oUSB","string":"string-lBTFEd","number":"number-kroeZH","boolean":"boolean-j3Zr1M","date":"date-rExxQZ","other":"other-iwNJ_K"};